import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const containerStyle = css`
  display: flex;
  flex-direction: column;
  border: 1px solid ${theme.colors.neutral20};
  border-radius: ${theme.borderRadius.small};
  padding: ${theme.spacing(1, 2, 1.5)};
  margin-top: ${theme.spacing(1)};
  margin-bottom: ${theme.spacing(2)};
  overflow: hidden;
`;

export const providerDetailsTextStyle = css`
  display: inline-flex;
  align-items: baseline;
  gap: ${theme.spacing(1)};

  .provider-name {
    display: inline-flex;
    overflow: hidden;

    > span {
      display: inline-block;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .timestamp {
    flex: 1;
    color: ${theme.colors.text.subdued};
    font-size: ${theme.font.size.small};
    white-space: nowrap;
  }
`;

export const noteTextStyle = css`
  margin-top: ${theme.spacing(1)};
  color: ${theme.colors.text.subdued};
  font-size: ${theme.font.size.medium};
  flex: 1;
  overflow: scroll;
`;
